import { BasePoolConfig, PoolInfo } from "../types";

export const mainnetInfo: Record<string, PoolInfo> = {
  // pt-weeth-26dec2024-weth
  "0xa77C2275C1F403056c7F73B44df69E374C299dd7": {
    maturityDate: "2024-12-26T00:00:00.000+00:00", // 1735171200 // https://etherscan.io/address/0x6ee2b5E19ECBa773a352E5B21415Dc419A700d1d#readContract#F8
    sparksPerQuotePerDay: 100,
    isPendle: true,
    isFarm: true,
    chainId: 1,
    notNativePendle: true,
    unwrap: "quote",
    flip: true,
    protocol: "Ether.fi",
    bonus: ["etherFi", "eigenLayer"],
  },
  //marginlyPool_pt-cornlbtc-26dec2024-wbtc
  "0x3D6f0097FA10f2e3855377daF2139dBeD66Fb343": {
    maturityDate: "2024-12-26T00:00:00.000+00:00",
    sparksPerQuotePerDay: 5000,
    isPendle: true,
    notNativePendle: true,
    isFarm: true,
    flip: true,
    chainId: 1,
    protocol: "",
  },
  // marginlyPool_pt-corn-unibtc-26dec2024-wbtc
  "0x056888DD4B31cA090E2FC7ca87AF62B588dD8207": {
    maturityDate: "2024-12-26T00:00:00.000+00:00",
    sparksPerQuotePerDay: 5000,
    isPendle: true,
    notNativePendle: true,
    isFarm: true,
    flip: true,
    chainId: 1,
    protocol: "",
  },
  // marginlyPool_pt-corn-pumpbtc-26dec2024-wbtc
  "0xEe368c5014D218795F76DcDA58e8FD24D04E19Ff": {
    maturityDate: "2024-12-26T00:00:00.000+00:00",
    sparksPerQuotePerDay: 5000,
    isPendle: true,
    notNativePendle: true,
    isFarm: true,
    flip: true,
    chainId: 1,
    protocol: "",
  },
  // marginlyPool_pt-pufeth-26dec2024-weth
  "0xa692B4fb38f8e9aEA229DA05CC2FC9d748218CD3": {
    maturityDate: "2024-12-26T00:00:00.000+00:00",
    sparksPerQuotePerDay: 100,
    isPendle: true,
    isFarm: true,
    notNativePendle: true,
    flip: true,
    chainId: 1,
    protocol: "",
  },
  // marginlyPool_pt-weeths-26dec2024-weth
  "0xaE2e6412d5c47e23c55c87e65cb2721Fa799Cb96": {
    maturityDate: "2024-12-26T00:00:00.000+00:00",
    sparksPerQuotePerDay: 100,
    isPendle: true,
    isFarm: true,
    notNativePendle: true,
    flip: true,
    chainId: 1,
    protocol: "",
  },
  // marginlyPool_pt-rseth-26dec2024-weth
  "0x49D7712f65B291E4574726d6e263a4E6Af2830F0": {
    maturityDate: "2024-12-26T00:00:00.000+00:00",
    sparksPerQuotePerDay: 100,
    isPendle: true,
    notNativePendle: true,
    isFarm: true,
    flip: true,
    chainId: 1,
    protocol: "",
  },
  // marginlyPool_pufeth-weth
  "0x51b5D4a7c58bE1d131D7BD027B5713e55efa0606": {
    sparksPerQuotePerDay: 100,
    isFarm: true,
    flip: true,
    chainId: 1,
    protocol: "",
  },
  // pt-weeth-26sep2024-weeth
  "0x4Cac44a1C50fea3F458f5F31529C0810AFcac497": {
    sparksPerQuotePerDay: 200,
    maturityDate: "2024-09-26T00:00:00.000+00:00",
    isPendle: true,
    isFarm: true,
    bonus: ["etherFi", "eigenLayer", "turtleDao"],
    chainId: 1,
    flip: true,
    protocol: "Ether.fi",
    finished: true,
  },
  // pt-ezeth-26sep2024-ezeth
  "0x48f6E31CFe4da92C2470f8b797aa89a9460E9975": {
    sparksPerQuotePerDay: 200,
    maturityDate: "2024-09-26T00:00:00.000+00:00",
    isPendle: true,
    isFarm: true,
    chainId: 1,
    flip: true,
    protocol: "Renzo",
    finished: true,
  },
  // pt-ezeth-26dec2024-ezeth
  "0xb34DfB03973e148ED800F369EdE84b92803116CA": {
    sparksPerQuotePerDay: 100,
    maturityDate: "2024-12-26T00:00:00.000+00:00",
    isPendle: true,
    isFarm: true,
    chainId: 1,
    flip: true,
    protocol: "Renzo",
  },
  // pt-amphreth-26sep2024-amphreth
  "0xAc02A14F647029d2B2FF937032A2EDDfc6255A06": {
    sparksPerQuotePerDay: 200,
    maturityDate: "2024-09-26T00:00:00.000+00:00",
    isPendle: true,
    isFarm: true,
    chainId: 1,
    flip: true,
    bonus: ["mellow2"],
    protocol: "Mellow",
    finished: true,
  },
  // pt-unieth-26sep2024-unieth
  "0x86DC30f6dBbb742463CE77f88926eff979892b22": {
    sparksPerQuotePerDay: 200,
    maturityDate: "2024-09-26T00:00:00.000+00:00",
    isPendle: true,
    isFarm: true,
    chainId: 1,
    flip: true,
    finished: true,
  },
  // pt-pzeth-26sep2024-pzeth
  "0x51f95AAF94834b878eec18A812D840910370887f": {
    sparksPerQuotePerDay: 100,
    maturityDate: "2024-09-26T00:00:00.000+00:00",
    isPendle: true,
    isFarm: true,
    chainId: 1,
    flip: true,
    bonus: ["mellow2"],
    protocol: "Mellow",
    finished: true,
  },
  // PT-rsETH-26SEP2024-rsETH
  "0xa16C1F55129E4Af8288c005a27c8fE05591d24bE": {
    sparksPerQuotePerDay: 200,
    maturityDate: "2024-09-26T00:00:00.000+00:00",
    isPendle: true,
    isFarm: true,
    chainId: 1,
    flip: true,
    bonus: ["kelp", "eigenLayer"],
    protocol: "Kelp",
    finished: true,
  },
  // pt-amphrlrt-26sep2024-amphrlrt
  "0x5e321551bA80b01051B24FeF2e44DA29313fC1ef": {
    sparksPerQuotePerDay: 200,
    maturityDate: "2024-09-26T00:00:00.000+00:00",
    isPendle: true,
    isFarm: true,
    chainId: 1,
    flip: true,
    bonus: ["mellow2"],
    protocol: "Amphor",
    finished: true,
  },
  // pt-rseth-26dec2024-rseth
  "0x548F66BC804CB806ae5Ba3FeeE492a49FD8ef173": {
    sparksPerQuotePerDay: 200,
    maturityDate: "2024-12-26T00:00:00.000+00:00",
    isPendle: true,
    isFarm: true,
    chainId: 1,
    flip: true,
    bonus: ["kelp2"],
    protocol: "Kelp",
  },
  // pt-ageth-26dec2024-ageth
  "0xafcC4F047a1012c4b51B69c7C1bB39C5F38F0305": {
    sparksPerQuotePerDay: 200,
    maturityDate: "2024-12-26T00:00:00.000+00:00",
    isPendle: true,
    isFarm: true,
    chainId: 1,
    flip: true,
    bonus: ["kelp2"],
    protocol: "Kelp",
  },
  // pt-amphrlrt-26dec2024-amphrlrt
  "0xcAbAE9295e274c152b9DcCC124AB06cf78d079Eb": {
    sparksPerQuotePerDay: 200,
    maturityDate: "2024-12-26T00:00:00.000+00:00",
    isPendle: true,
    isFarm: true,
    chainId: 1,
    flip: true,
    bonus: ["mellow2"],
    protocol: "Amphor",
  },
  // unibtc-wbtc
  "0x8A171afA8Db2a01E8b280c12db0F5bc2EEEcdc10": {
    sparksPerQuotePerDay: 200,
    isFarm: true,
    chainId: 1,
    flip: true,
    protocol: "Bedrock",
  },
  // pt-ebtc-26dec2024-ebtc
  "0x2F06faF2A2EEFfBd44a796b8c6d2D04841c6488C": {
    sparksPerQuotePerDay: 5000,
    maturityDate: "2024-12-26T00:00:00.000+00:00",
    isPendle: true,
    isFarm: true,
    chainId: 1,
    flip: true,
    protocol: "Ether.fi",
    bonus: ["etherFi", "eigenLayer"],
  },
  // pt-weeths-26dec2024-weeths
  "0xee07F58A274Ebc50f79ccd1d67fF73426a317dAf": {
    sparksPerQuotePerDay: 200,
    maturityDate: "2024-12-26T00:00:00.000+00:00",
    isPendle: true,
    isFarm: true,
    chainId: 1,
    flip: true,
    protocol: "Ether.fi",
    bonus: ["etherFi", "eigenLayer"],
  },
  // pt-pufeth-26dec2024-pufeth
  "0x1F1A9004F00571Ea0Ed79e51bfd2Cdc3954abc40": {
    sparksPerQuotePerDay: 200,
    maturityDate: "2024-12-26T00:00:00.000+00:00",
    isPendle: true,
    isFarm: true,
    chainId: 1,
    flip: true,
    protocol: "Puffer",
  },
  // pt-amphreth-26dec2024-amphreth
  "0x530043876F37170468a9F366145E645BEE86da6C": {
    sparksPerQuotePerDay: 200,
    maturityDate: "2024-12-26T00:00:00.000+00:00",
    isPendle: true,
    isFarm: true,
    chainId: 1,
    flip: true,
    bonus: ["mellow2"],
    protocol: "Mellow",
  },
  // pt-re7lrt-26dec2024-re7lrt
  "0x2Df52e18e0fcA1E8CEE272cD034368278a49125f": {
    sparksPerQuotePerDay: 200,
    maturityDate: "2024-12-26T00:00:00.000+00:00",
    isPendle: true,
    isFarm: true,
    chainId: 1,
    flip: true,
    protocol: "Mellow",
  },
  // pt-cornlbtc-26dec2024-lbtc
  "0x32d850609FDc950bF6E23640d1EB0bbd60a5149c": {
    sparksPerQuotePerDay: 5000,
    maturityDate: "2024-12-26T00:00:00.000+00:00",
    isPendle: true,
    isFarm: true,
    chainId: 1,
    flip: true,
    protocol: "Corn",
  },
  "0xd136839D9978CAa3780a5D7a19a0322f3618A49D": {
    // marginlyPool_ezeth-weth
    sparksPerQuotePerDay: 100,
    isFarm: true,
    chainId: 1,
    flip: true,
  },
  "0x4819C556E87aDf28dB19e850480886F62D37f46A": {
    // marginlyPool_weeth-weth
    sparksPerQuotePerDay: 100,
    isFarm: true,
    chainId: 1,
    flip: true,
  },
  "0xef2424e938E48F92b77AB193a5AA669D90B1ebc1": {
    // marginlyPool_rseth-weth
    sparksPerQuotePerDay: 100,
    isFarm: true,
    chainId: 1,
    flip: true,
  },
  "0x4727835Ee3AdBb9b69eebc13b5d4e36943e2eEC5": {
    // marginlyPool_unieth-weth
    sparksPerQuotePerDay: 100,
    isFarm: true,
    chainId: 1,
    flip: true,
  },
  "0xB95b9f7763de009a4E6c739855faCDfA960eB893": {
    // marginlyPool_pt-lbtc-27mar2025-wbtc
    sparksPerQuotePerDay: 5000,
    isFarm: true,
    notNativePendle: true,
    chainId: 1,
    isPendle: true,
    maturityDate: "2025-03-27T00:00:00.000+00:00",
    flip: true,
  },
  "0xf7710a79F2440423e5865EB3a7DF3e47a430859F": {
    // pt-lbtc-27mar2025-lbtc
    sparksPerQuotePerDay: 5000,
    isFarm: true,
    chainId: 1,
    isPendle: true,
    maturityDate: "2025-03-27T00:00:00.000+00:00",
    flip: true,
  },
  "0xd88855292819e34388833A3cb5524eEDf25010AE": {
    // pt-ebtc-27mar2025-ebtc
    sparksPerQuotePerDay: 5000,
    isFarm: true,
    chainId: 1,
    isPendle: true,
    maturityDate: "2025-03-27T00:00:00.000+00:00",
    flip: true,
  },
};
export const mainnetPools: BasePoolConfig[] = [
  // pt-weeth-26dec2024-weth
  {
    address: "0xa77C2275C1F403056c7F73B44df69E374C299dd7",
    uniswapAddress: "0x7d372819240d14fb477f17b964f95f33beb4c704", // https://github.com/eq-lab/marginly/blob/c04aa1a816415fa599d8d1a37d268cbdb51f49c4/packages/deploy/src/data/deploy/ethereum-v1.5-pendle/config.json#L93
  },
  // pt-weeth-26dsep2024-weeth
  {
    address: "0x4Cac44a1C50fea3F458f5F31529C0810AFcac497",
    uniswapAddress: "0xc8edd52d0502aa8b4d5c77361d4b3d300e8fc81c", // https://github.com/eq-lab/marginly/blob/c04aa1a816415fa599d8d1a37d268cbdb51f49c4/packages/deploy/src/data/deploy/ethereum-v1.5-pendle/config.json#L102
  },
  // pt-ezeth-26sep2024-ezeth
  {
    address: "0x48f6E31CFe4da92C2470f8b797aa89a9460E9975",
    uniswapAddress: "0xcdbd5ff3e03b6828db9c32e2131a60aba5137901", // https://github.com/eq-lab/marginly/blob/c04aa1a816415fa599d8d1a37d268cbdb51f49c4/packages/deploy/src/data/deploy/ethereum-v1.5-pendle/config.json#L102
  },
  // pt-ezeth-26dec2024-ezeth
  {
    address: "0xb34DfB03973e148ED800F369EdE84b92803116CA",
    uniswapAddress: "0xd8f12bcde578c653014f27379a6114f67f0e445f", // https://github.com/eq-lab/marginly/blob/c04aa1a816415fa599d8d1a37d268cbdb51f49c4/packages/deploy/src/data/deploy/ethereum-v1.5-pendle/config.json#L102
  },
  // pt-pzeth-26sep2024-pzeth
  {
    address: "0x51f95AAF94834b878eec18A812D840910370887f",
    uniswapAddress: "0xd3bb297264bd6115ae163db4153038a79d78acba", // https://github.com/eq-lab/marginly/blob/c04aa1a816415fa599d8d1a37d268cbdb51f49c4/packages/deploy/src/data/deploy/ethereum-v1.5-pendle/config.json#L102
  },
  // pt-amphreth-26sep2024-amphreth
  {
    address: "0xAc02A14F647029d2B2FF937032A2EDDfc6255A06",
    uniswapAddress: "0x901e710c2f634131b36e3c68b072ed5db9250f3e", // https://github.com/eq-lab/marginly/blob/c04aa1a816415fa599d8d1a37d268cbdb51f49c4/packages/deploy/src/data/deploy/ethereum-v1.5-pendle/config.json#L102
  },
  // PT-rsETH-26SEP2024-rsETH
  {
    address: "0xa16C1F55129E4Af8288c005a27c8fE05591d24bE",
    uniswapAddress: "0x6b4740722e46048874d84306b2877600abcea3ae",
  },
  // pt-amphrlrt-26sep2024-amphrlrt
  {
    address: "0x5e321551bA80b01051B24FeF2e44DA29313fC1ef",
    uniswapAddress: "0xb9e8bb1105382b018c6adfd95fd9272542cc1776",
  },
  // pt-rseth-26dec2024-rseth
  {
    address: "0x548F66BC804CB806ae5Ba3FeeE492a49FD8ef173",
    uniswapAddress: "0x84a50177a84dad50fdbf665dfbfb39914b52dff2",
  },
  // pt-ageth-26dec2024-ageth
  {
    address: "0xafcC4F047a1012c4b51B69c7C1bB39C5F38F0305",
    uniswapAddress: "0x6010676bc2534652ad1ef5fa8073dcf9ad7ebfbe",
  },
  // pt-amphrlrt-26dec2024-amphrlrt
  {
    address: "0xcAbAE9295e274c152b9DcCC124AB06cf78d079Eb",
    uniswapAddress: "0x7e0f3511044afdad9b4fd5c7fa327cbeb90beebf",
  },
  // unibtc-wbtc
  {
    address: "0x8A171afA8Db2a01E8b280c12db0F5bc2EEEcdc10",
    uniswapAddress: "0x3a32F5040Bc4d8417e78E236eb2C48c90e003FDa",
  },
  // pt-ebtc-26dec2024-ebtc
  {
    address: "0x2F06faF2A2EEFfBd44a796b8c6d2D04841c6488C",
    uniswapAddress: "0x36d3ca43ae7939645c306e26603ce16e39a89192",
  },
  // pt-weeths-26dec2024-weeths
  {
    address: "0xee07F58A274Ebc50f79ccd1d67fF73426a317dAf",
    uniswapAddress: "0x40789e8536c668c6a249af61c81b9dfac3eb8f32",
  },
  // pt-pufeth-26dec2024-pufeth
  {
    address: "0x1F1A9004F00571Ea0Ed79e51bfd2Cdc3954abc40",
    uniswapAddress: "0x676106576004ef54b4bd39ce8d2b34069f86eb8f",
  },
  // pt-amphreth-26dec2024-amphreth
  {
    address: "0x530043876F37170468a9F366145E645BEE86da6C",
    uniswapAddress: "0x1c48cd1179aa0c503a48fcd5852559942492e31b",
  },
  // pt-re7lrt-26dec2024-re7lrt
  {
    address: "0x2Df52e18e0fcA1E8CEE272cD034368278a49125f",
    uniswapAddress: "0x1c5b54c0bd500a7430ed34bd2413af17725a7840",
  },
  // pt-cornlbtc-26dec2024-lbtc
  {
    address: "0x32d850609FDc950bF6E23640d1EB0bbd60a5149c",
    uniswapAddress: "0xcae62858db831272a03768f5844cbe1b40bb381f",
  },
  // pt-unieth-26sep2024-unieth
  {
    address: "0x86DC30f6dBbb742463CE77f88926eff979892b22",
    uniswapAddress: "0xbae2df4dfcd0c613018d6056a40077f2d1eff28a",
  },
  {
    // marginlyPool_ezeth-weth
    address: "0xd136839D9978CAa3780a5D7a19a0322f3618A49D",
    uniswapAddress: "0xbe80225f09645f172b079394312220637c440a63",
  },
  {
    // marginlyPool_weeth-weth
    address: "0x4819C556E87aDf28dB19e850480886F62D37f46A",
    uniswapAddress: "0x202a6012894ae5c288ea824cbc8a9bfb26a49b93",
  },
  {
    // marginlyPool_rseth-weth
    address: "0xef2424e938E48F92b77AB193a5AA669D90B1ebc1",
    uniswapAddress: "0x059615ebf32c946aaab3d44491f78e4f8e97e1d3",
  },
  {
    // marginlyPool_unieth-weth
    address: "0x4727835Ee3AdBb9b69eebc13b5d4e36943e2eEC5",
    uniswapAddress: "0x0f2f4d68308db60d36268a602ef273421a227021",
  },
  {
    // marginlyPool_pufeth-weth
    address: "0x51b5D4a7c58bE1d131D7BD027B5713e55efa0606",
    uniswapAddress: "0xbf7d01d6cddecb72c2369d1b421967098b10def7",
  },
  {
    // marginlyPool_pt-lbtc-27mar2025-wbtc
    address: "0xB95b9f7763de009a4E6c739855faCDfA960eB893",
    uniswapAddress: "0x70b70ac0445c3ef04e314dfda6caafd825428221", // https://github.com/eq-lab/marginly/blob/b27d2b2760fbdbd365360d98e68b507268ce9097/packages/deploy/src/data/deploy/ethereum-v1.5-pendle/config.json#L1052
  },
  {
    // marginlyPool_pt-pufeth-26dec2024-weth
    address: "0xa692B4fb38f8e9aEA229DA05CC2FC9d748218CD3",
    uniswapAddress: "0x676106576004ef54b4bd39ce8d2b34069f86eb8f", // https://github.com/eq-lab/marginly/blob/b27d2b2760fbdbd365360d98e68b507268ce9097/packages/deploy/src/data/deploy/ethereum-v1.5-pendle/config.json#L409C28-L409C70
  },
  {
    // marginlyPool_pt-weeths-26dec2024-weth
    address: "0xaE2e6412d5c47e23c55c87e65cb2721Fa799Cb96",
    uniswapAddress: "0x40789e8536c668c6a249af61c81b9dfac3eb8f32", // https://github.com/eq-lab/marginly/blob/b27d2b2760fbdbd365360d98e68b507268ce9097/packages/deploy/src/data/deploy/ethereum-v1.5-pendle/config.json#L1091
  },
  {
    // marginlyPool_pt-rseth-26dec2024-weth
    address: "0x49D7712f65B291E4574726d6e263a4E6Af2830F0",
    uniswapAddress: "0x84a50177a84dad50fdbf665dfbfb39914b52dff2", // https://github.com/eq-lab/marginly/blob/b27d2b2760fbdbd365360d98e68b507268ce9097/packages/deploy/src/data/deploy/ethereum-v1.5-pendle/config.json#L1099
  },
  {
    // marginlyPool_pt-cornlbtc-26dec2024-wbtc
    address: "0x3D6f0097FA10f2e3855377daF2139dBeD66Fb343",
    uniswapAddress: "0xcae62858db831272a03768f5844cbe1b40bb381f", // https://github.com/eq-lab/marginly/blob/b27d2b2760fbdbd365360d98e68b507268ce9097/packages/deploy/src/data/deploy/ethereum-v1.5-pendle/config.json#L409C28-L409C70
  },
  {
    // marginlyPool_pt-corn-unibtc-26dec2024-wbtc
    address: "0x056888DD4B31cA090E2FC7ca87AF62B588dD8207",
    uniswapAddress: "0x40deae18c3ce932fdd5df1f44b54d8cf3902787b", // https://github.com/eq-lab/marginly/blob/b27d2b2760fbdbd365360d98e68b507268ce9097/packages/deploy/src/data/deploy/ethereum-v1.5-pendle/config.json#L409C28-L409C70
  },
  {
    // marginlyPool_pt-corn-pumpbtc-26dec2024-wbtc
    address: "0xEe368c5014D218795F76DcDA58e8FD24D04E19Ff",
    uniswapAddress: "0xf8208fb52ba80075af09840a683143c22dc5b4dd", // https://github.com/eq-lab/marginly/blob/b27d2b2760fbdbd365360d98e68b507268ce9097/packages/deploy/src/data/deploy/ethereum-v1.5-pendle/config.json#L409C28-L409C70
  },
  {
    // marginlyPool_pt-lbtc-27mar2025-lbtc
    address: "0xf7710a79F2440423e5865EB3a7DF3e47a430859F",
    uniswapAddress: "0x70b70ac0445c3ef04e314dfda6caafd825428221",
  },
  {
    // marginlyPool_pt-ebtc-27mar2025-ebtc
    address: "0xd88855292819e34388833A3cb5524eEDf25010AE",
    uniswapAddress: "0x2c71ead7ac9ae53d05f8664e77031d4f9eba064b",
  },
];
